<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-post
      </v-icon>
      Blogs List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createBlog()"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
          create new
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              :hint="isSearchAdded ? searchHint : ''"
              append-icon="mdi-magnify"
              outlined
              dense
              @keyup.enter="handleSearch"
              @keydown.esc="clearSearch"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="paginatedBlogsList"
        :search="search"
        class="elevation-1"
        disable-sort
        :items-per-page="itemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30]
        }"
        :server-items-length="totalFilteredRecords"
        :options.sync="options"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.blog.title }}</td>
            <td>{{ item.blog.created_at | convertToLocal }}</td>
            <td>{{ item.blog.type }}</td>
            <td v-if="item.tags.length > 0">
              <font
                v-for="tag in item.tags"
                :key="tag.id"
              >
                <v-chip outlined>
                  {{ tag.name }}
                </v-chip>
              </font>
            </td>
            <td v-else>
              N/A
            </td>
            <td>{{ item.blog.category.name }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click="editBlog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="confirmDelete(item)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                v-if="item.blog.type !== 'published'"
                class="mt-n2"
                elevation="1"
                small
                color="green"
                @click="confirmPublish(item)"
              >
                <v-icon color="white">
                  mdi-earth
                </v-icon>&nbsp; Publish
              </v-btn>
              <v-btn
                v-else
                class="mt-n2"
                elevation="1"
                small
                color="grey"
                disabled
              >
                <v-icon color="white">
                  mdi-check
                </v-icon>&nbsp; Published
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <delete-dialog
      v-if="showDelete"
      :title="'Delete Blog?'"
      @closed="showDelete = false"
      @confirmed="deleteConfirmed()"
    />
    <delete-dialog
      v-if="showPublish"
      :title="'Publish Blog'"
      :message="'Are you sure you want to publish ?'"
      :button1="'No'"
      :button2="'Yes'"
      @closed="showPublish = false"
      @confirmed="publishConfirmed()"
    />
  </v-container>
</template>
  <script>
  import { storageUrl } from 'src/app-globals';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
  import moment from 'moment';
  import Constants from 'src/constants';

  export default {
    name: 'Blogs',
    components: {
      'centre-spinner': spinner,
      'delete-dialog': DeleteDialog,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        search: null,
        showForm: false,
        options: {},
        headers: [
          { text: 'Title', align: 'start', value: 'title' },
          { text: 'Created At', value: 'created_at' },
          { text: 'Status', value: 'status' },
          { text: 'Tags', value: 'tags' },
          { text: 'Category', value: 'category' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
          { text: 'Publish', value: 'publish' },
        ],
        loading: false,
        page: 1,
        itemsPerPage: 10,
        pageStart: 0,
        itemForDelete: null,
        showDelete: false,
        showPublish: false,
        itemForPublish: null,
      };
    },
    computed: {
      blogs () {
        return this.$store.getters['blogs/getBlogsList'];
      },
      paginatedBlogsList () {
        var list = this.$store.getters['blogs/getBlogsList'];
        return list.data;
      },
      totalFilteredRecords () {
        if (Object.keys(this.blogs).length > 0) {
          return this.blogs.total;
        }
        return 0;
      },
      searchHint () {
        return `Press Enter to filter by name: '${this.search}' or press ESC to clear.`;
      },
      isSearchAdded () {
        if (this.search === null || this.search === '') {
          return false;
        }
        return true;
      },
    },
    watch: {
      options: {
        async handler () {
          await this.paginatedCall();
        },
        deep: true,
      },
    },
    methods: {
      async fetchBlogsList () {
        this.loading = true;
        await this.$store.dispatch('blogs/fetchBlogsList', {
          params: {
            limit: this.itemsPerPage,
            startPage: this.pageStart,
            title: this.search !== '' ? this.search : null,
          },
        });
        this.loading = false;
      },
      async paginatedCall () {
        this.itemsPerPage = this.options.itemsPerPage;
        this.pageStart = this.options.page * this.itemsPerPage - this.itemsPerPage;
        this.fetchBlogsList();
      },
      async handleSearch () {
        this.options.page = 1;
        this.pageStart = 0;
        await this.fetchBlogsList();
      },
      async clearSearch () {
        this.options.page = 1;
        this.pageStart = 0;
        this.search = null;
        await this.fetchBlogsList();
      },
      getFilePath (fileName) {
        return storageUrl + fileName;
      },
      confirmDelete (item) {
        this.itemForDelete = item;
        this.showDelete = true;
      },
      async deleteConfirmed () {
        this.loading = true;
        await this.$store.dispatch('blogs/deleteBlog', {
          id: this.itemForDelete.blog.id,
        }).then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Blog deleted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
        });
        this.showDelete = false;
        this.options.page = 1;
        this.pageStart = 0;
        await this.fetchBlogsList();
        this.loading = false;
      },
      createBlog () {
        this.$router.push('/blogs/create');
      },
      editBlog (item) {
        this.$router.push(`/blogs/${item.blog.slug}`);
      },
      confirmPublish (item) {
        this.itemForPublish = item;
        this.showPublish = true;
      },
      async publishConfirmed () {
        this.showPublish = false;
        this.loading = true;
        await this.$store.dispatch('blogs/publishBlog', {
          id: this.itemForPublish.blog.id,
        }).then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Blog published successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.fetchBlogsList();
          this.loading = false;
        });
        this.loading = false;
      },
    },
  };
  </script>
  <style scoped>
  .title-style {
    color: #37474F;
  }
  .icon-style {
    color: #37474F;
    font-size: 45px;
  }
  .v-data-table::v-deep th {
    font-size: 12px !important;
    color: #37474F !important;
    font-weight: bold !important;
  }
  .v-data-table::v-deep td {
    font-size: 13px !important;
    color: #37474F !important;
  }
  .theme--light.v-data-table tbody tr:nth-of-type(even) {
    background-color: #CFD8DC
  }
  .v-data-table { background-color: #ECEFF1; }
  .font-my-style {
    font-weight: bold;
  }
  </style>
